import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../../sass/style.scss";
import { VisibilityProvider } from "../../context/VisibilityContext";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";
import Navbar from "../../layout/Navbar/Navbar";
import Activity from "../../sections/Activity/Activity";
import Advantages from "../../sections/Advantages/Advantages";
import Gallery from "../../sections/Gallery/Gallery";
import History from "../../sections/History/History";
// import AnimatedSection from "../../ui/AnimatedSection/AnimatedSection";

function App() {
	useEffect(() => {
		document.title = "GLuck Esports";
	})
	const [isNavbarVisible, setIsNavbarVisible] = useState(true);
	const mainContentRef = useRef(null);
	const galleryRef = useRef(null);

	const controlNavbar = useCallback(() => {
		if (!galleryRef.current) return;

		const scrollY = window.scrollY;
		const galleryPosition = galleryRef.current.offsetTop;
		const offset = 400;

		setIsNavbarVisible(scrollY < galleryPosition - offset);
	}, []);

	const handleScroll = useCallback(() => {
		controlNavbar();

		const mainContent = mainContentRef.current;
		if (!mainContent) return;

		// Static footer on mobile — no parallax translate
		if (window.innerWidth <= 768) {
			mainContent.style.transform = "";
			return;
		}

		const scrollPosition = window.scrollY;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		const footerHeight = 850;
		const bottomThreshold = documentHeight - windowHeight - footerHeight;
		const activationThreshold = bottomThreshold - windowHeight * 0.5;
		const maxTranslateY =
			window.innerWidth >= 3840
				? 1100
				: window.innerWidth >= 2560
				? 450
				: 300;

		let translateY = 0;

		if (scrollPosition > activationThreshold) {
			const progress =
				(scrollPosition - activationThreshold) /
				(bottomThreshold - activationThreshold);
			const easedProgress = Math.pow(progress, 3);
			translateY = -Math.min(easedProgress * footerHeight, maxTranslateY);
		}

		mainContent.style.transform = `translateY(${translateY}px)`;
	}, [controlNavbar]);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		handleScroll();

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [handleScroll]);

	return (
		<VisibilityProvider>
			<div className="App">
				<Navbar isVisible={isNavbarVisible} />
				
				<div className="main-content" ref={mainContentRef}>
					<Header />
					<Activity />
					<History />
					<Advantages />
					<div ref={galleryRef}>
						<Gallery />
					</div>
				</div>
				<Footer />
			</div>
		</VisibilityProvider>
	);
}

export default App;
